import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "big-eye-root" }
const _hoisted_2 = {
  id: "road_dayan_b",
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  class: "svg"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("circle", {
  cx: "6",
  cy: "6",
  r: "6",
  stroke: "none"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("circle", {
  cx: "6",
  cy: "6",
  r: "5",
  fill: "none"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock("svg", _hoisted_2, [
      _createVNode("g", {
        id: "Ellipse_11",
        "data-name": "Ellipse 11",
        fill: "none",
        stroke: _ctx.mdata.type === 0 ? 'red' : 'blue',
        "stroke-width": "2"
      }, [
        _hoisted_3,
        _hoisted_4
      ], 8, ["stroke"])
    ]))
  ]))
}